import styled from "styled-components"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../../ui/tabs"
import { Button } from "../../../ui/button"
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "../../../ui/dropdown-menu"
import { Input } from "../../../ui/input"
import SimpleTable from '../../components/SimpleTable'
import { useEffect, useState } from "react"
import { useNavigate, useParams } from 'react-router-dom'
import { Alert, Row, Col, Modal, Spin, Toaster, toast, Form, Select } from './../../../ui/ot'
import RenewSettingProTableOt from './../../components/RenewSettingProTableOt'
import { useBorrower } from "../../controllers/BorrowerController"
import { useItem } from './../../controllers/ItemController';
import { useCheckout } from "../../controllers/CheckoutController"
import { useHold } from "../../controllers/HoldController"
import { useLibrary } from "../../controllers/LibraryController"
import HoldsProTableOt from "../../components/HoldsProTableOt"
import { useTranslation } from 'react-i18next';



const LanContainer = styled.div`
width: 100%;
display: flex;
-webkit-box-pack: center;
justify-content: space-around;
flex-direction: row;
-webkit-box-align: start;
align-items: start;
gap: 0.5em;
flex-wrap: nowrap;
`

const SubTitle = styled.div`
text-align: left;
// width: 90%;
font-size: 1.1em;
font-weight: 600;
padding-bottom: 0.5em;
}
`

const WhiteBox = styled.div`
background - color: #fff;
padding: 1em;
width: -webkit - fill - available;
`


const RenewSetting = ({
    propsForm,
    keyPrefix = "library.backstage.Circulation.RenewSetting",
    defaultSelectedRowsInfo = [],
    defaultSelectedRowsKeys = [],
}) => {
    const { t } = useTranslation('translation', { keyPrefix: keyPrefix })
    const { borrowernumber } = useParams()
    const navigate = useNavigate()
    const [form_] = Form.useForm();
    const form = propsForm || form_

    const {
        BorrowerData,
        getBorrowerData,
    } = useBorrower({
        onBefore: () => {

        },
        onFinish: () => {

        }
    })

    const {
        postCheckoutData
    } = useCheckout({
        onFinish: (value) => {
            const axiosMode = value?.axiosMode
            const axiosStatus = value?.status
            switch (axiosMode) {
                case 'post':
                    if (axiosStatus === 'success') toast.success('借閱成功 !')
                    else if (value?.message === "Checkout not authorized (DEBT)") toast.error('借閱失敗 ! 有違規請洽櫃檯。')
                    else toast.error('借閱失敗')
                    break;
                default:
                    break;
            }

        }
    })

    const {
        postHoldData
    } = useHold({
        onFinish: (value) => {
            const axiosMode = value?.axiosMode
            const axiosStatus = value?.status
            switch (axiosMode) {
                case 'post':
                    if (axiosStatus === 'success') toast.success('預約成功 !')
                    else if (value?.message === "Hold cannot be placed. Reason: itemAlreadyOnHold") toast.error('預約失敗 ! 已超過預約數。')
                    else toast.error('預約失敗')
                    break;
                default:
                    break;
            }

        }
    })

    useEffect(() => {
        getBorrowerData({
            borrowernumber: borrowernumber
        })
    }, [borrowernumber])

    const onSelectChange = (selectedRowsInfo) => {
        form.setFieldsValue({ selectedRowsInfo: selectedRowsInfo })
    }

    const borrower = BorrowerData?.find(_ => true)

    return (
        <>
            <Toaster richColors position="top-center" />
            {/* <LanContainer>
                <WhiteBox>
                    <Row gutter={[8, 8]}>
                        <RenewForm
                            borrowernumber={borrowernumber}
                            borrower={borrower}
                            onCheckout={({ itemnumber }) => postCheckoutData([
                                {
                                    borrowernumber: borrowernumber,
                                    itemnumber: itemnumber
                                }
                            ])}
                            onHold={({ itemnumber, pickupLibrary }) => postHoldData([
                                {
                                    borrowernumber: borrowernumber,
                                    itemnumber: itemnumber,
                                    pickupLibrary: pickupLibrary
                                }
                            ])}
                        />
                    </Row>
                </WhiteBox>
            </LanContainer> */}
            <Tabs defaultValue="0" className="w-full">
                <TabsContent value="0">
                    <WhiteBox>
                        <RenewSettingProTableOt
                            // borrowernumber={borrowernumber}
                            // keyPrefix={keyPrefix + ".borrowed_list"}
                            defaultSelectedRowsInfo={defaultSelectedRowsInfo}
                            defaultSelectedRowsKeys={defaultSelectedRowsKeys}
                            onSelectChange={onSelectChange}
                            customColumns={[]}
                            extraActionRender={(item) => {
                                return (<></>)
                            }}
                            toolBarRender={(item) => {
                                return ([
                                    ...item,
                                    // <Button></Button>
                                ])
                            }}
                            customFormItems={(fieldName) => {
                                return (<></>)
                            }}
                            propsRowKey='key'
                        />
                    </WhiteBox>
                </TabsContent>
            </Tabs>
        </>
    )
}

export default RenewSetting



const RenewForm = ({
    keyPrefix = "library.backstage.Circulation.RenewSetting",
    borrower = {},
    borrowernumber,
    onCheckout = () => { },
    onHold = () => { },
}) => {
    const { t } = useTranslation('translation', { keyPrefix: keyPrefix })
    const [barcode, setBarcode] = useState('');
    const [modealOpen, setModalOpen] = useState(false)
    const [loading, setLoading] = useState(false)

    const onCheckoutClick = () => {
        setModalOpen(true)
        getItemData({
            barcode: barcode,
            borrowernumber: borrowernumber
        })
    }


    const {
        ItemData,
        getItemData
    } = useItem({
        onBefore: () => {
            setLoading(true)
        },
        onFinish: () => {
            setLoading(false)
        },
    })

    return <>
        <Col span={24}>
            <SubTitle>{t("patron")} : {borrower?.surname} ({borrower?.cardnumber})</SubTitle>
            {/* <LanContainer>
                <Input placeholder='Enter item barcode' onChange={e => setBarcode(e.target.value)} />
                <Button onClick={onCheckoutClick}>{t("borrowing")}</Button>
            </LanContainer> */}
        </Col>
    </>
}
